import { Popconfirm, Tooltip } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { routingConstants } from "@/Constants/routingConstants";
import { updateActiveStep } from "@/reducers/client_user/roleAccess";
import { TOOLTIPTEXT, roleAccessValidation } from "@/utilities/CommonText";
import { showErrorToast } from "@/utilities/utils";

const AddRoleAccessteps = () => {
  const { activeStep, stepsValidated, roleAccessData } = useSelector(
    (state) => state.clientRoles,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const stepsArr = [
    {
      step: 1,
      title: "Role & Branch Access",
      type: "basic",
    },
    {
      step: 2,
      title: "Module Access",
      type: "moduleAccess",
    },
    {
      step: 3,
      title: "Feature Access",
      type: "featureAccess",
    },
  ];

  return (
    <div className="addRoleAccessSteps_Wrapper mb-5">
      <div className="grid grid-flow-col gap-2 rounded-lg bg-white p-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-8 lg:grid-cols-5">
          {stepsArr.map((item, index) => {
            return (
              <div
                className={`flex cursor-pointer flex-col gap-2`}
                key={index}
                onClick={() => {
                  if (activeStep === 1 && stepsValidated[stepsArr[1].type]) {
                    if (
                      roleAccessData.roleName === "" ||
                      roleAccessData.roleName.trim() === ""
                    ) {
                      showErrorToast(roleAccessValidation.roleName);
                      return;
                    }
                    if (
                      user?.is_headoffice === 1 &&
                      user?.login_as === "main_client"
                    ) {
                      if (roleAccessData.branchAccessIds.length === 0) {
                        showErrorToast(roleAccessValidation.branchId);
                        return;
                      }
                    }
                  }

                  if (stepsValidated[item.type]) {
                    dispatch(updateActiveStep(item.step));
                  }
                }}
              >
                <div className="flex h-[34px] items-end !gap-[23px]">
                  <span
                    className={`select-none text-[16px] leading-[normal] ${stepsValidated[item.type] ? "font-bold text-black" : "font-semibold text-txtColor"}`}
                  >
                    {item.title}
                  </span>
                </div>
                <div
                  className={`!h-[5px] rounded-sm ${stepsValidated[item.type] ? "bg-primary" : "bg-lightblue"}`}
                ></div>
              </div>
            );
          })}
        </div>

        <div className="grid items-center justify-end">
          <Tooltip title={TOOLTIPTEXT.addrolecancel}>
            <Popconfirm
              description={
                <>
                  <div className="max-w-[300px] p-4">
                    <p className="text-[16px] font-semibold leading-[normal] text-black">
                      Are you sure you want to cancel add, All the changes will
                      get lost
                    </p>
                  </div>
                </>
              }
              okButtonProps={{
                className:
                  "bg-primary text-white border !border-primary hover:!bg-white hover:!text-primary",
              }}
              cancelButtonProps={{
                className:
                  "bg-white text-primary border !border-primary hover:!bg-primary hover:!text-white",
              }}
              okText="Yes"
              cancelText="No"
              icon={null}
              onConfirm={() => {
                navigate(routingConstants?.clientRole);
              }}
            >
              <button className="items-center text-red outline-none ring-0">
                <RejectIcon />
              </button>
            </Popconfirm>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default AddRoleAccessteps;
